.StreamateCamera {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;

  .backdropContainer {
    overflow: hidden;
    height: 100%;
    width: 100%;
  }

  .backdrop {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    filter: blur(18px);
    opacity: 0.5;
    aspect-ratio: 1080 / 1920;

    :global(.phone) &,
    :global(.tablet) & {
      aspect-ratio: 1 / 1;
    }

    :global(.fullScreen.desktop) & {
      display: none;
    }
  }

  .playerContainer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .overlap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 1;
  }

  .controls {
    position: absolute;
    top: auto;
    bottom: 95px;
    right: 16px;
    width: 40px;
    height: fit-content;
    overflow: hidden;
    text-align: center;
    z-index: 2;

    :global(.phone) &,
    :global(.tablet) & {
      right: 20px;
      bottom: 85px;
    }
  }

  .modelInfo {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 1rem;
    width: 100%;
    z-index: 1;
    cursor: pointer;
  }

  .ctaBubble {
    pointer-events: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: 9px;
    right: 9px;
    bottom: 12px;
    padding: 16px;
    border-radius: var(--semantics-radius-16);
    background: var(--miscellaneous-graphite-70, rgb(25, 25, 25, 0.70));
  }

  .liveBadge {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -7px;
    padding: 2px 5px;
    font: var(--font-caption-lg-semibold);
    background: var(--Join-LIVE-ad, #D70004);
    color: var(--primitives-colors-neutral-0);
    border-radius: var(--semantics-radius-999);
    z-index: 10;

    :global(.phone) &,
    :global(.tablet) & {
      font-size: 10px;
      bottom: -9px;
    }
  }

  .joinBtn {
    appearance: none;
    border: 0;
    padding: 5px 16px;
    background: var(--Join-LIVE-ad, #D70004);
    color: var(--primitives-colors-neutral-0);
    border-radius: var(--semantics-radius-12);
    cursor: pointer;
    font: var(--font-body-sm-medium);
    font-weight: 700;
    white-space: nowrap;
  }

  .ctaText {
    display: flex;
    min-width: 0;
    color: var(--primitives-colors-neutral-0);
    font: var(--font-body-md-medium);

    :global(.phone) &,
    :global(.tablet) & {
      font-size: 14px;
    }
  }

  .model {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
    flex-shrink: 1;
    max-width: 100%;
  }

  .status {
    white-space: nowrap;
  }

  .callToActions {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    min-width: 0;
    max-width: 74%;
    flex-shrink: 1;
  }

  video {
    width: 100%;
    object-fit: cover !important;

    :global(.fullScreen.desktop) & {
      object-fit: contain !important;
    }
  }
}

.message {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: absolute;
  top: 0;
}

.modelAvatar {
  width: 100%;
  height: 100%;
  object-fit: cover; 
  object-position: center;
  display: block;
  border-radius: var(--semantics-radius-999);
  z-index: 10;
  border: 2px solid var(--primitives-colors-neutral-0);
}

.avatar {
  --pulseBase: calc(40px * 1.06);
  --pulsemaxscale: 1.1;
  --pulseColor: 215,0,4;

  display: flex;
  position: relative;
  width: 40px; 
  height: 40px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--primitives-colors-neutral-980);
  border: 2px solid var(--primitives-colors-neutral-0);
  box-shadow: 0 2px 6px rgb(0,0,0,0.35);
  z-index: 2;

  :global(.phone) &,
  :global(.tablet) & {
    --pulseBase: calc(32px * 1.05);

    width: 32px;
    height: 32px;
  }

  &::before {
    content: '';
    position: absolute;
    left: 50%; 
    top: 50%;
    width: var(--pulseBase); 
    height: var(--pulseBase);
    transform: translate(-50%, -50%) scale(1);
    border-radius: 50%;
    pointer-events: none;
    z-index: 1;
    background: rgb(215, 0, 4, 0.90);
    box-shadow:
      0 0 0 1px rgb(var(--pulseColor), .50),
      0 0 5px 5px rgb(var(--pulseColor), .40);
    opacity: 1;
    animation: ring-pulse 3s ease-in-out infinite;
  }
}

@keyframes ring-pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: .9;
    box-shadow:
      0 0 0 1px rgb(215, 0, 4, 0.70),
      0 0 5px 5px rgb(215, 0, 4, 0.30);
  }

  35% {
    transform: translate(-50%, -50%) scale(1.05);
    opacity: .75;
    box-shadow:
      0 0 0 2px rgb(215, 0, 4, 0.85),
      0 0 8px 8px rgb(215, 0, 4, 0.45);
  }

  65% {
    transform: translate(-50%, -50%) scale(var(--pulsemaxscale));
    opacity: .60;
    box-shadow:
      0 0 0 3px rgb(215, 0, 4, 0.50),
      0 0 10px 9px rgb(215, 0, 4, 0.40);
  }
}
